import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import StandardFieldLabel from '../formFieldWrapper/standardFieldLabel';
import styles from './styles.scss';
const cx = classnames.bind(styles);
class BaseRadioField extends Component {
    static propTypes = {
        className: PropTypes.string,
        elmId: PropTypes.string,
        size: PropTypes.string,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
            .isRequired,
        compact: PropTypes.bool,
    };
    static defaultProps = {
        className: '',
        elmId: 'base_radio_field',
        compact: true,
    };
    render() {
        const { elmId, size, className, label, compact, ...rest } = this.props;
        let newCompact = compact;
        if (typeof this.props.size !== 'undefined') {
            newCompact = size === 'small';
        }
        const labelProps = {
            checkboxType: 'radio',
            compact: newCompact,
            className,
            elmId,
        };
        const standardLabel = StandardFieldLabel.createFromLabel(label, labelProps);
        return (_jsx(Radio, { "data-elm-id": `${elmId}_radio_option`, className: cx('root', className, { medium: !compact }), label: standardLabel, ...rest }));
    }
}
export default BaseRadioField;
//# sourceMappingURL=index.js.map